//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    components: {},
    directives: {
        focus: {
            componentUpdated: function (el) {
                el.focus()
                // console.log(document.activeElement)
            }
        }
    },
    data() {
        return {
            isAnimate: false,
            isAlertShow: false,
            isLoanChannel: false,
            prevBodyStyle_scrollTop:'',
            prevBodyStyle_top:'',
            prevBodyStyle_position:'',
            prevBodyStyle_width:'',

        }
    },
    
    methods: {
        showAlert() {
            this.isAlertShow = true;
            this.isAnimate = true;
            this.beforeMount() //弹出框之后页面不可滚动
        },
        closeAlert() {
            this.isAnimate = false;
            this.isAlertShow = false;
            this.beforeDestroy() //页面可以滚动
        },
        sureAlert(callb) {
            const callback = callb;
            if (callback && typeof callback == 'function') {
                callback();
            }
        },
        beforeMount() {
            // 获取原来的scrollTop 并将body的top修改为对应的值
            this.prevBodyStyle_scrollTop = document.body.scrollTop || document.documentElement.scrollTop
            this.prevBodyStyle_top = window.getComputedStyle(document.body, null).getPropertyValue('top')
            document.body.style.top = `-${this.prevBodyStyle_scrollTop}px`
            // 获取原来body的position 为了解决iOS上光标漂移的问题 将position修改为fixed
            this.prevBodyStyle_position = window.getComputedStyle(document.body, null).getPropertyValue('position')
            document.body.style.position = 'fixed'
            // 为了避免width空值的情况
            this.prevBodyStyle_width = window.getComputedStyle(document.body, null).getPropertyValue('width')
            document.body.style.width = '100%'
        },
        beforeDestroy() {
            document.body.style.top = this.prevBodyStyle_top || '0px'
            document.body.style.position = this.prevBodyStyle_position
            document.body.style.width = this.prevBodyStyle_width || '100%'
            document.body.scrollTop = document.documentElement.scrollTop = this.prevBodyStyle_scrollTop || 0
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/alert/index.vue